// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { FormikContextType } from 'formik'
import { FC } from 'react'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../../containers/EmbroideryService'
import {
  EmbroideryFormKind,
  IconFormValues,
} from '../../../../../containers/EmbroideryService/types'
import { EmbroideryPlacementDetails } from '../../../../../types/graphql'
import { PlacementSelector } from '../../selectors/PlacementSelector'
import { IconPlacementWrapper } from '../../shared-form-styles'

interface Props {
  labelId: string
  iconPlacements: EmbroideryPlacementDetails[] | null
  form: Pick<
    FormikContextType<IconFormValues>,
    'values' | 'setFieldError' | 'setFieldTouched' | 'setFieldValue' | 'errors' | 'touched'
  >
  kind: EmbroideryFormKind | null
}

export const IconPlacement: FC<Props> = ({ labelId, form, iconPlacements, kind }) => {
  const { choosePlacement } = EmbroideryService.useContainer()

  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  if (!iconPlacements) return null

  const handleSelectIconPlacement = (iconPlacement: EmbroideryPlacementDetails) => {
    choosePlacement(kind, {
      ...iconPlacement,
      // We never want to show anything other than chest for Icon + Text Embroidery 1.5 // Kyle Corbelli 07/27/2020
      flatlayKind: 'flatlay-chest',
    })
    form.setFieldValue('iconPlacement', iconPlacement)
  }

  return (
    <IconPlacementWrapper>
      <PlacementSelector
        errorMessage={form.touched.iconPlacement ? form.errors.iconPlacement : undefined}
        label={fixtures.iconOption.iconPlacementLabel}
        labelId={labelId}
        onSelectPlacement={handleSelectIconPlacement}
        placementOptions={iconPlacements}
        selectedPlacementOption={form.values.iconPlacement}
      />
    </IconPlacementWrapper>
  )
}
